import { render, staticRenderFns } from "./ResourceMonitoringPage.vue?vue&type=template&id=04e2733e&scoped=true"
import script from "./ResourceMonitoringPage.vue?vue&type=script&lang=js"
export * from "./ResourceMonitoringPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e2733e",
  null
  
)

export default component.exports